import {
	normalizePostTypeLabels,
	updatePostTypeLabel,
} from './post-type-utils.mjs';

const { PanelBody, PanelRow, SelectControl, TextControl } = wp.components;
const { useEffect, useMemo, useState } = wp.element;
const { __ } = wp.i18n;

export function PostTypeLabelPanel({
	postTypes,
	postTypeLabels,
	setAttributes,
}) {
	const labels = useMemo(
		() => normalizePostTypeLabels(postTypeLabels),
		[postTypeLabels]
	);
	const [selectedPostType, setSelectedPostType] = useState(
		postTypes[0]?.value || ''
	);

	useEffect(() => {
		if (labels !== postTypeLabels) {
			setAttributes({ post_type_label: {} });
		}
	}, [labels, postTypeLabels, setAttributes]);

	useEffect(() => {
		if (!postTypes.some(({ value }) => value === selectedPostType)) {
			setSelectedPostType(postTypes[0]?.value || '');
		}
	}, [postTypes, selectedPostType]);

	if (postTypes.length === 0) {
		return null;
	}

	return (
		<PanelBody
			title={__('Post Types Labels', 'simple-sitemap')}
			initialOpen={false}
		>
			<PanelRow className="simple-sitemap order">
				<div style={{ width: '125px' }}>
					<SelectControl
						label={__('Post type', 'simple-sitemap')}
						value={selectedPostType}
						options={postTypes}
						onChange={setSelectedPostType}
					/>
				</div>
			</PanelRow>
			<PanelRow>
				<TextControl
					label={__('New Label', 'simple-sitemap')}
					value={labels[selectedPostType] || ''}
					onChange={(value) =>
						setAttributes({
							post_type_label: updatePostTypeLabel(
								labels,
								selectedPostType,
								value
							),
						})
					}
				/>
			</PanelRow>
		</PanelBody>
	);
}
